module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp23_5012.2c12009e.png";